// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"8f639c2c","707":"3424a9dc","729":"6a387e29"}[chunkId] + ".js";
};